<template lang="pug">
v-card(height="100%" flat v-if="dataLoad")
    div(
      :class="sectionDelete ? 'disable-quicklinks-list-block-title' : 'quicklinks-list-block-title'"
      )
        div().arrowTitle
            div().rightIcons
              v-icon(
                v-show="isAdmin && !switchUser"
                @click="changeIsAdmin()"
                title="Edit Section"
              ).btnIcon edit
              v-icon(
                v-show="isCollapsed"
                @click="changeCollapsed()"
              ).btnCollapsed keyboard_arrow_down
              v-icon(
                v-show="!isCollapsed"
                @click="changeCollapsed()"
              ).btnCollapsed keyboard_arrow_up
            div(v-show="isAdmin && switchUser").arrowDiv
              v-icon(
                :class="[checkUpward(index) ? 'disableIcon' : 'enableIcon']"
                @click="checkUpward(index) ? '' : upButtonClick()"
                v-bind:style="selectUp"
              ) arrow_upward
              v-spacer(style="height:10px")
              v-icon(
                :class="checkDownward(index) ? 'disableIcon' : 'enableIcon'"
                @click="checkDownward(index) ? '' : downButtonClick()"
                v-bind:style="selectDown"
              ) arrow_downward
            div().titleDiv
                span(
                    v-show="!switchUser"
                    v-bind:style="{ color: sectionHeaderColour }"
                ).sectionTitle {{ sectionHeader }}
                v-text-field(
                    v-show="isAdmin && switchUser"
                    v-model="editTitle"
                    box
                    color="#9EA5A3"
                    label="Section Title"
                    required
                    hide-details=true
                    :maxlength="120"
                    :disabled="sectionDelete"
                )
        div().allIcons
            v-icon(
              v-show="isAdmin && switchUser && !sectionDelete"
              @click="changeDelete()"
              title="Disable Section"
            ).deleteIcon visibility_off
            v-icon(
              v-show="isAdmin && switchUser && sectionDelete"
              @click="changeRestore()"
              title="Restore Section"
            ).deleteIcon restore
            v-icon(
              v-show="isAdmin && switchUser && list.length <= 0"
              @click="deleteSection()"
              title="Delete Section"
            ).btnDelete delete
            v-icon(
              v-show="isAdmin && switchUser"
              @click="editSection()"
              title="Save Changes"
            ).btnSave save
    div(v-show="!isCollapsed")
      v-container(fluid v-show="!isAdmin || !switchUser")
          v-card-title(v-show="isAdmin && switchUser")
          v-container
              .list-table
                  ul(class="lu-li").imgWordBox-list
                      li(class="lu-li").list-item.imgWordBox(
                                  v-for="(item, index) in list"
                                  :index="index"
                                  :key="index"
                                  :item="item"
                      )
                          v-card().card-list
                              a(@click="getLink(item)" target="_blank")
                                  .top-img
                                    img(
                                      :class="sectionDelete ? 'disableImg' : ''"
                                      v-if="isImage(item.icon)"
                                      :src="item.icon?remapColors(item.icon):'https://s3-us-west-2.amazonaws.com/ce-quicklinks.compliengine.com/icons90/Bookings.png'"
                                      v-bind:style="{width: cardDefaultWidth}"
                                      ).iconPadding
                                  v-card-text(
                                    text-xs-centered
                                    v-bind:style="{width: cardDefaultWidth}"
                                    ).card-text
                                      v-icon(
                                          v-if="!isImage(item.icon)"
                                          color='primary' style="font-size: 90px;") home
                                      div(
                                        v-bind:style="{fontSize: cardFontSize}"
                                      ).linksTitle
                                        span {{item.title}}

      v-container(fluid v-show="isAdmin && switchUser")
              v-container
                      .list-table
                          SortableList(
                              :distance=2
                              axis="xy"
                              v-model="list"
                              @sort-end="sortListing($event)"
                              helperClass="cs-slicksort-fix"
                              )
                              SortableItem.list-item(
                                  v-for="(item, index) in list"
                                  :index="index"
                                  :key="index"
                                  :item="item"
                                  :disabled="sectionDelete"
                              )
                                  v-card(onselectstart="return false;")
                                      .editViewImage
                                        img(
                                          :class="sectionDelete ? 'disableImg' : ''"
                                          v-if="isImage(item.icon)" :src="item.icon?remapColors(item.icon):'https://s3-us-west-2.amazonaws.com/ce-quicklinks.compliengine.com/icons90/Bookings.png'"
                                          v-bind:style="{width: cardDefaultWidth}"
                                          ).iconPadding
                                      v-card-text(
                                        text-xs-centered
                                        v-bind:style="{width: cardDefaultWidth}"
                                      ).cardText
                                          v-icon(
                                              v-if="!isImage(item.icon)"
                                              color='primary' style="font-size: 90px;") home
                                          div(
                                            v-bind:style="{fontSize: cardFontSize}"
                                          ).linksTitle
                                            span {{item.title}}
                                      v-divider(light)
                                      v-card-actions(style="justify-content: flex-end")
                                            v-icon(
                                              :class="sectionDelete ? 'disableIcon' : 'enableIcon'"
                                              @click="sectionDelete ? '' : editLink(index)"
                                              title="Edit Link"
                                            ) edit
                                            v-icon(
                                              :class="sectionDelete ? 'disableIcon' : 'enableIcon'"
                                              @click="sectionDelete ? '' : showVersion(index)"
                                              title="Show Versions"
                                            ) list
                                            v-icon(
                                              :class="sectionDelete ? 'disableIcon' : 'enableIcon'"
                                              @click="sectionDelete ? '' : disableLink(index)"
                                              title="Disable Link"
                                            ) visibility_off
                              li(
                                class="lu-li"
                                style="display:flex"
                                ).list-item
                                v-card(
                                  v-bind:style="{ width: cardDefaultWidth, height: addCardHeight }"
                                  @click="sectionDelete ? '' : addQuickLink()"
                                  onselectstart="return false;"
                                  ).addCard
                                  v-icon(
                                    :class="sectionDelete ? 'disableIcon' : 'enableIcon'"
                                  ).btnAdd add
      v-container(fluid v-show="isAdmin && switchUser")
        div Disabled Quick Links
            v-container
                .list-table
                    ul(class="lu-li")
                        li(
                          class="lu-li"
                        ).list-item(v-for="(item, disabledIndex) in disabledList"
                                :index="disabledIndex"
                                :key="disabledIndex"
                                :item="item"
                        )
                            v-card(onselectstart="return false;")
                                .editViewImage
                                  img(
                                    v-bind:style="{width: cardDefaultWidth}"
                                  ).iconPadding.disableImg(v-if="isImage(item.icon)" max-width="90px" :src="item.icon?remapColors(item.icon):'https://s3-us-west-2.amazonaws.com/ce-quicklinks.compliengine.com/icons90/Bookings.png'")
                                v-card-text(
                                  text-xs-centered
                                  v-bind:style="{width: cardDefaultWidth}"
                                  ).cardText
                                    v-icon(
                                        v-if="!isImage(item.icon)"
                                        color='grey' style="font-size: 90px;") home
                                    div(
                                      v-bind:style="{fontSize: cardFontSize}"
                                    ).linksTitle
                                      span {{item.title}}
                                v-divider(light)
                                v-card-actions(style="justify-content: flex-end")
                                    v-icon(
                                      :class="sectionDelete ? 'disableIcon' : 'enableIcon'"
                                      @click="sectionDelete ? '' : reactivateLink(disabledIndex)"
                                      title="Restore Link"
                                    ) restore
                                    v-icon(
                                      :class="sectionDelete ? 'disableIcon' : 'enableIcon'"
                                      @click="sectionDelete ? '' : deleteLink(disabledIndex)"
                                      title="Delete Link"
                                    ) delete
    add-quick-link-module-dialog(
        :qlSet="qlSet"
        :show-dialog="showAddDialog"
        :list = "list"
        :index = "index"
        :organisation = "organisation"
        @closed="showAddDialog=false"
        @reloadQuick="reloadQuickLink"
        ref="child"
    )
    delete-quick-link-module-dialog(
        :qlSet="qlSet"
        :show-dialog="showDeleteDialog"
        :index = "index"
        :organisation = "organisation"
        @closed="showDeleteDialog=false"
        @reloadQuickList="getLinkDetails"
        ref="delete"
    )
    version-quick-link-module-dialog(
        :show-dialog="showVersionDialog"
        @closed="showVersionDialog=false"
        @submit-add="getLinkDetails"
        ref="version"
    )
</template>
<script>
import Base from '@/components/views/Base';
import { mapGetters, mapState } from 'vuex';
import { ContainerMixin, ElementMixin } from 'vue-slicksort';
import AddQuickLinkModuleDialog from '@/components/content/AddQuickLinkModuleDialog';
import DeleteQuickLinkModuleDialog from '@/components/content/DeleteQuickLinkModuleDialog';
import VersionQuickLinkModuleDialog from '@/components/content/VersionQuickLinkModuleDialog';
import { quicklink, blobs, section } from '@/api';
import sortArray from '@/lib/sortArray';
import moment from 'moment';
import VClamp from 'vue-clamp';

const SortableList = {
    mixins: [ContainerMixin],
    template: `
        <ul class="lu-li">
            <slot />
        </ul>
    `,
};

const SortableItem = {
    mixins: [ElementMixin],
    props: ['item'],
    template: `
        <li class="lu-li">
                <slot />
        </li>
    `,
};

export default {
    name: 'Quicklinks',
    extends: Base,
    components: {
        SortableItem,
        SortableList,
        AddQuickLinkModuleDialog,
        DeleteQuickLinkModuleDialog,
        VersionQuickLinkModuleDialog,
        VClamp
    },

    props: {
        sectionHeaderColour: { type: String, required: true },
        sectionHeader: { type: String, required: true },
        qlSet: { type: String, required: true },
        editRole: { type: Number, required: true },
        collapsed: { type: Boolean, required: true },
        id: { type: Number, required: true },
        index: { type: Number, required: true },
        sectionLists: { type: Array, default: () => { return []; } },
        currentSectionLists: { type: Array, default: () => { return []; } },
        resultLists: { type: Array, default: () => { return []; } },
        disableLists: { type: Array, default: () => { return []; } },
        quicklinks: { type: Array, default: () => { return []; } },
        isEditView: { type: Boolean, default: false },
        isMoveChange: { type: Boolean, default: false },
        sectionTempName: { type: String, default: null },
        sectionTempCollapsed: { type: Boolean, default: null },
        sectionHidden: { type: Boolean, required: true },
        cardDefaultWidth: { type: String, default: '120px' },
        cardFontSize: { type: String, default: '12px' },
        organisation: { type: String, required: true },
    },

    data() {
        return {
            list: [],
            disabledList: [],
            showAddDialog: false,
            showDeleteDialog: false,
            showVersionDialog: false,
            isAdmin: true,
            switchUser: false,
            lineNumber: this.$store.state.appearance.characterLimitLine,
            dataLoad: false,
            isHideEdit: true,
            max: 30,
            editTitle: '',
            moveNumber: 0,
            selectUp: {},
            selectDown: {},
            openFileType: ['.pdf', '.gif', '.jp2', '.jpe', '.jpeg', '.jpg', '.png', '.bmp'],
            sectionDelete: false,
            sectionDisable: false,
            sectionDeleteFrontend: false,
            addCardHeight: '',
            isCollapsed: false,
        };
    },

    computed: {
        ...mapGetters({
            isAuthenticated: 'session/isAuthenticated',
            quickLinks: 'quickLinks/quickLinks',
            emptyLink: 'quickLinks/emptyLink'
        }),
        ...mapState({
            role: state => state.session.role,
            subdomain: state => state.session.subdomain
        }),
    },

    created() {
        if (this.isAuthenticated()) {
            this.getLinkDetails();
            this.isAdmin = this.role >= this.editRole;
            window.addEventListener('scroll', () => {
                this.showDisabledModal = false;
                this.showModal = false;
            });
            this.sectionDelete = this.sectionHidden;
            this.isCollapsed = this.collapsed;
        }
    },

    watch: {
        moveNumber(value) {
            if (value === 0) {
                this.selectUp = {};
                this.selectDown = {};
            }
            if (value === -1) {
                this.selectUp = { border: '1px solid var(--v-secondary-base)' };
                this.selectDown = {};
            }
            if (value === 1) {
                this.selectUp = {};
                this.selectDown = { border: '1px solid var(--v-secondary-base)' };
            }
        },

        isMoveChange(value) {
            this.list = this.resultLists;
            this.disabledList = this.disableLists;
            this.switchUser = this.isEditView;
            this.sectionDelete = this.sectionHidden;
            if (this.sectionTempName) {
                this.editTitle = this.sectionTempName;
            } else {
                this.editTitle = this.sectionHeader;
            }
            this.isAdmin = this.role >= this.editRole;
            if (this.sectionTempCollapsed != null) {
                this.isCollapsed = this.sectionTempCollapsed;
            } else {
                this.isCollapsed = this.collapsed;
            }
        },

        showAddDialog(value) {
            if (value) {
                this.disableScrollBar();
            } else {
                this.enableScrollBar();
            }
        },

        showVersionDialog(value) {
            if (value) {
                this.disableScrollBar();
            } else {
                this.enableScrollBar();
            }
        },

        list(value) {
            this.addCardHeight = value.length === 0 ? '151px' : '';
        }
    },

    methods: {
        isImage(itemIcon) {
            return itemIcon.includes('data:image') || itemIcon.includes('http');
        },

        async getLinkDetails() {
            this.list = this.quicklinks;
            this.disabledList = this.list.filter(item => item.hidden && item.deleted !== true);
            this.list = this.list.filter(item => !item.hidden && item.deleted !== true);
            this.list = this.list.sort((a, b) => {
                return a.priority - b.priority;
            });
            this.$emit('setResultList', this.index, this.list);
            this.disabledList = this.disabledList.sort((a, b) => {
                return moment(a.updated_at) > moment(b.updated_at);
            });
            this.$emit('setDisableList', this.index, this.disabledList);
            this.dataLoad = true;
        },

        showFile(blob, fileName) {
            // Source: https://blog.jayway.com/2017/07/13/open-pdf-downloaded-api-javascript/
            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                window.navigator.msSaveOrOpenBlob(blob, fileName);
                return;
            }
            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(blob);
            const fileExtension = fileName.substring(fileName.lastIndexOf('.'));
            if (this.openFileType.indexOf(fileExtension) !== -1) {
                const win = window.open('', '_blank');
                win.location.href = data; // eslint-disable-line no-param-reassign
            } else {
                const link = document.createElement('a');
                link.href = data;
                link.download = fileName;
                document.body.appendChild(link);
                link.click();
                setTimeout(() => {
                    // For Firefox it is necessary to delay revoking the ObjectURL
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(data);
                }, 100);
            }
        },

        getLink(item) {
            if (item.tags[0] === 'file') {
                this.setLoading(true);
                let id = item.url.split('/');
                id = id[id.length - 1];
                blobs.getLinks(id, this.subdomain).then((result) => {
                    try {
                        // FIXME: Workaround for our server not sending
                        // Content-Disposition. Load balancer issue?
                        const contentType = result.headers['content-type'];
                        let fileName = result.headers['content-disposition'];
                        fileName = fileName.substring(fileName.indexOf('=') + 1);
                        fileName = fileName.substring(1, fileName.length - 1);
                        const blob = new Blob([result.data],
                            { type: contentType });
                        this.showFile(blob, fileName);
                    } catch (err) {
                        console.log(err);
                    } finally {
                        this.setLoading(false);
                    }
                });
            } else {
                window.open(item.url, '_blank');
            }
        },

        changeIsAdmin() {
            this.switchUser = !this.switchUser;
            this.$emit('editStateSave', this.index, this.switchUser);
            this.editTitle = this.sectionHeader;
            this.sectionDelete = this.sectionHidden;
            this.sectionDisable = this.sectionHidden;
            this.moveNumber = 0;
            this.selectUp = {};
            this.selectDown = {};
        },

        changeDelete() {
            this.sectionDelete = true;
        },
        deleteSection() {
            this.sectionDeleteFrontend = true;
            this.$emit('deleteSection', this.index);
        },
        changeRestore() {
            this.sectionDelete = false;
        },

        upButtonClick() {
            this.$emit('setSectionTempName', this.index, this.editTitle);
            this.$emit('setSectionTempCollapsed', this.index, this.isCollapsed);
            this.$emit('moveUpDown', this.index, sortArray.actions.UP);
        },

        downButtonClick() {
            this.$emit('setSectionTempName', this.index, this.editTitle);
            this.$emit('setSectionTempCollapsed', this.index, this.isCollapsed);
            this.$emit('moveUpDown', this.index, sortArray.actions.DOWN);
        },

        saveView() {
            this.switchUser = !this.switchUser;
            this.$emit('editStateSave', this.index, this.switchUser);
        },

        reactivateLink(disabledIndex) {
            // set as seen and update the pirority as the last item in list
            this.disabledList[disabledIndex].hidden = false;
            if (this.list.length > 0) {
                this.disabledList[disabledIndex].priority =
                this.list[this.list.length - 1].priority + 1;
            } else {
                this.disabledList[disabledIndex].priority = 1;
            }
            this.disabledList[disabledIndex].version += 1;
            this.disabledList[disabledIndex].updated_at = new Date();
            // calling API for create new version of quick link
            quicklink.createVersion(this.disabledList[disabledIndex], this.subdomain);
            // add the list to the activated list
            this.list.push(this.disabledList[disabledIndex]);
            // Remove the item from the list
            this.disabledList = this.disabledList.filter(item => item.hidden);
            // Hide the modal
            this.showDisabledModal = false;
        },

        disableLink(index) {
            try {
                this.setLoading(true);
                // alter the current hovered item to be hidden/ disabled
                this.list[index].hidden = true;
                this.list[index].version += 1;
                this.list[index].updated_at = new Date();
                // calling API for create new version of quick link
                quicklink.createVersion(this.list[index], this.subdomain);
                this.disabledList.push(this.list[index]);
                this.list = this.list.filter(item => !item.hidden);
            } catch (err) {
                console.log(err);
            } finally {
                this.setLoading(false);
            }
        },
        deleteLink(index) {
            this.$refs.delete.LoadEditLink(this.disabledList[index]);
            this.showDeleteDialog = true;
        },
        editLink(index) {
            this.$refs.child.LoadEditLink(this.list[index]);
            this.showAddDialog = true;
        },

        showVersion(index) {
            this.$refs.version.LoadVersion(this.list[index]);
            this.showVersionDialog = true;
        },

        clearHover() {
            this.index = -1;
        },

        clearDisabledLink() {
            this.disabledHoverIndex = -1;
        },

        addQuickLink() {
            this.$refs.child.LoadCreateLink();
            this.showAddDialog = true;
        },

        async sortListing(event) {
            if (event.newIndex === event.oldIndex) {
                return;
            }
            try {
                this.setLoading(true);
                let start = event.oldIndex;
                let end = start;
                let isMoveLeft = false;
                if (event.oldIndex > event.newIndex) {
                    start = event.newIndex;
                    isMoveLeft = true;
                } else {
                    end = event.newIndex;
                }

                let index = 0;
                let newList = [];
                const changeItems = [];
                this.list.forEach((element) => {
                    // elements that are not moved, before start index
                    if (index < start) {
                        newList.push(element);
                    }
                    // elements that is moved to,
                    // changes its index and push to new list with it's index
                    if (index === start) {
                        if (isMoveLeft) {
                            // if move left, all other items in between should shift right, +1
                            // first push the moved element
                            this.list[end].priority = this.list[start].priority;
                            changeItems.push(this.list[end]);
                            newList.push(this.list[end]);
                            // push the current item, with the priority
                            this.list[index].priority += 1;
                            changeItems.push(this.list[index]);
                            newList.push(this.list[index]);
                        } else {
                            // do nothing as the item should be shifted. handle at end side.
                        }
                    }
                    // elements that is between start and end, all shift by 1
                    if (index > start && index < end) {
                        if (isMoveLeft) {
                            this.list[index].priority += 1;
                        } else {
                            this.list[index].priority -= 1;
                        }
                        changeItems.push(this.list[index]);
                        newList.push(this.list[index]);
                    }
                    // elements that is moved from
                    if (index === end) {
                        if (isMoveLeft) {
                            // if move left, no action needed as it is pushed to start
                        } else {
                            // if move right, current item shift left, -1,
                            // then insert the shifted item
                            // push the current item, with the priority
                            // in case the two items are next to each other,
                            // setting the moved element before altering the component
                            this.list[start].priority = this.list[end].priority;
                            this.list[index].priority -= 1;
                            changeItems.push(this.list[index]);
                            newList.push(this.list[index]);
                            // then push the moved element
                            changeItems.push(this.list[start]);
                            newList.push(this.list[start]);
                        }
                    }
                    // elements that are not moved, after end index
                    if (index > end) {
                        newList.push(element);
                    }
                    index++;
                });

                this.list = newList;
                newList = [];
                for (let i = 0; i < changeItems.length; i++) {
                    // eslint-disable-next-line
                    await quicklink.changePriority(changeItems[i]);
                }
            } catch (err) {
                console.log(err);
            } finally {
                this.setLoading(false);
            }
        },

        async editSection() {
            this.switchUser = !this.switchUser;
            this.$emit('editStateSave', this.index, this.switchUser);
            if (this.editTitle === '' && this.sectionDelete === this.sectionHidden) {
                return;
            }
            if (this.editTitle !== this.sectionHeader
            || this.isCollapsed !== this.collapsed) {
                const sectionItem = {
                    organisation: this.organisation,
                    updated_at: new Date()
                };
                if (this.editTitle !== this.sectionHeader) {
                    sectionItem.title = this.editTitle;
                }
                if (this.isCollapsed !== this.collapsed) {
                    sectionItem.collapsed = this.isCollapsed;
                }
                const response = await section.update(this.id, sectionItem);
                if (this.editTitle !== this.sectionHeader) {
                    this.sectionHeader = response.data.title;
                    this.$emit('setSectionTitle', this.index, this.sectionHeader);
                }
                if (this.isCollapsed !== this.collapsed) {
                    this.collapsed = response.data.collapsed;
                }
            }
            if (this.sectionDelete !== this.sectionHidden) {
                if (this.sectionDelete) {
                    this.$emit('disableSection', this.index);
                } else {
                    this.$emit('restoreSection', this.index);
                }
            }
        },

        disableScrollBar() {
            const mo = function disable(e) { e.preventDefault(); };
            document.body.style.overflow = 'hidden';
            document.addEventListener('touchmove', mo, false);
        },

        enableScrollBar() {
            const mo = function enable(e) { e.preventDefault(); };
            document.body.style.overflow = '';
            document.removeEventListener('touchmove', mo, false);
        },

        checkUpward(index) {
            return (index === 0 || this.sectionDisable === true || this.sectionDelete === true);
        },
        checkDownward(index) {
            const enableSections = this.currentSectionLists.filter(item => !item.hidden);
            return ((index + 1) === enableSections.length
                || this.sectionDisable === true || this.sectionDelete === true);
        },

        reloadQuickLink(index, list) {
            this.$emit('setResultList', index, list);
        },

        changeCollapsed() {
            this.isCollapsed = !this.isCollapsed;
        }
    }
};
</script>
<style scoped>
.lu-li{
  list-style: none;
  margin: 0;
  padding: 0;
  flex-wrap: wrap;
}
.list-table{
    position: relative;
}
.arrowTitle{
    position: relative;
}
.arrowDiv{
    float:left
}
.list-table ul{
    padding: 0;
    display: flex;
}
.list-table ul li{
  display: inline-block;
}
.list-table p{
    width: 100px;
}
.list-table ul .imgWordBox .top-img{
    text-align: center;
    margin: 0 auto;
}
.list-table ul .imgWordBox .top-img > img {
    max-width: 180px;
    min-width: 80px;
}
.list-table ul .imgWordBox .v-card__text{
  padding: 5px 0;
  text-align: center;
  line-height: 14px;
  font-size: 12px;
}
.quickLinkImg{
    padding: 5px;
    width:80px;
    height:80px;
}
.list-item{
    margin: 5px;
    /* flex: 1 1 auto; */
}
.list-item ::selection {
    background-color: transparent !important;
    color: var(--v-secondary-base) !important;
}
.editViewImage{
    text-align: center;
    margin: 0 auto;
    background-color: #EEEDE9;
}

.cardText{
  padding: 5px 0;
  text-align: center;
  line-height: 14px;
  font-size: 12px;
  background-color: #EEEDE9;
  max-width: 180px;
  min-width: 80px;
}

.disableImg{
    -webkit-filter: grayscale(1);
    filter: gray;
    filter: grayscale(1);
}

/* Below are kludges to style the dynamic content generated by vue-slicksort*/
.cs-slicksort-fix div:first-of-type{
    border-radius: 10px;
    background-color: #A0A0A0;
}
.cs-slicksort-fix .flex:first-of-type{
    padding: 12px 12px 12px 12px;
}

.cs-slicksort-fix div {
    font-family: 'Roboto', sans-serif;
    line-height: 1.5;
}

.quicklinks-list-block-title {
    border-bottom:1px solid var(--v-secondary-base);
    padding-bottom: 12px;
}

.disable-quicklinks-list-block-title {
    border-bottom:1px solid #696969;
    padding-bottom: 12px;
}

.allIcons{
    display: flex;
    justify-content: flex-end;
    margin-right: 18px;
}
.allIcons i{
    margin: 3px
}
.rightIcons{
    color: var(--v-secondary-base);
    float: right;
}
.btnAdd {
    font-size: 80px;
    color: var(--v-secondary-base);
    display:block;
    /* margin-top: 25px; */
}

.linksTitle {
    color:#696969;
    font-weight:bold;
    height:28px;
}
.linksTitle ::selection {
    background-color: transparent !important;
    color: #696969 !important;
}
.sectionTitle {
    font-size: 15px;
    font-weight: bold;
}
.disableIcon {
    color: #696969 !important;
    display:block;
}
.enableIcon {
    color: var(--v-secondary-base);
    display:block;
}
.addCard {
    justify-content:center;
    background-color: #EEEDE9;
    cursor:pointer;
    display: flex;
    align-items:center;
    max-width: 180px;
    min-width: 80px;
}
.card-text {
    max-width: 180px;
    min-width: 80px;
}
.v-card__actions {
    padding: 4px !important;
}

.container {
  padding: 5px;
}

.iconPadding {
  padding: 7%;
}


</style>



// WEBPACK FOOTER //
// src/components/views/dashboard/QuicklinksList.vue